import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Prompt from "../prompt";
import { getGdprPromptText } from "../../store/gdpr";

const GDPRPrompt = ({ promptText }) => {
  return <Prompt promptText={promptText} />;
};

GDPRPrompt.propTypes = {
  promptText: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  promptText: getGdprPromptText(state)
});

export { GDPRPrompt };
export default connect(mapStateToProps)(GDPRPrompt);
